/* eslint-disable no-unused-vars */
import React, { useLayoutEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { ReactComponent as ClockIcon } from '../../../../../assets/icons/clock-icon.svg'
import CategorySelector from './CategorySelector'
import { addNewExpenditure, updateExpenditure } from '../../../../../Redux/expenses/expensesSlice'
import { useTranslation } from 'react-i18next'
import { getTiraneDateString } from '../../../../../utils/dateFormatter'

const index = ({ close, data }) => {
  const { t } = useTranslation() || ((text) => text)

  const { editing, exp } = data || {}
  const initDate = getTiraneDateString()
  const dispatch = useDispatch()
  const [selectedCategory, setSelectedCategory] = useState(null)

  // Add date formatting function
  const formatDateToEuropean = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Add date parsing function
  const parseEuropeanDate = (dateString) => {
    if (!dateString) return '';
    const [day, month, year] = dateString.split('/');
    if (!day || !month || !year) return '';
    return `${year}-${month}-${day}`;
  };

  const submitData = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const formObject = {
      date: formData.get('date'),
      category: selectedCategory?.value || 'others',
      description: formData.get('description') || '',
      paid_amount: Number(formData.get('paid_amount')) || 0,
      createdAt: new Date().toISOString(), // Add creation timestamp
      close
    }
    if (!editing) {
      dispatch(addNewExpenditure(formObject))
    } else if (editing && exp) {
      dispatch(
        updateExpenditure({
          ...formObject,
          id: exp.id
        })
      )
    }
  }
  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.form_header}>
        <h2 className={styles.header_text}>{editing ? t('EDIT_EXPENDITURE') : t('ADD_NEW_EXPENDITURE')}</h2>
        <button className={styles.close_btn} onClick={close}>
          ✖
        </button>
      </div>
      <form className={styles.popup_from_container} onSubmit={submitData}>
        <div className={styles.form_entry}>
          <label className={styles.entry_label}>{t('date')}</label>
          <div className={styles.time_container}>
            <div className={styles.time_date_container}>
              <ClockIcon className={styles.time_indicator_icon} />
              <input
                type='date'
                id='date'
                name='date'
                defaultValue={initDate}
                className={styles.entry_input}
                required
                lang="en-GB"
                onFocus={(e) => {
                  // Set the date format to DD/MM/YYYY when focused
                  if (e.target.value) {
                    const date = new Date(e.target.value);
                    e.target.value = date.toLocaleDateString('en-GB');
                  }
                }}
                onBlur={(e) => {
                  // Convert back to YYYY-MM-DD for the date input
                  if (e.target.value) {
                    const [day, month, year] = e.target.value.split('/');
                    if (day && month && year) {
                      e.target.value = `${year}-${month}-${day}`;
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className={`${styles.form_entry} ${styles.operation_entry}`}>
          <CategorySelector t={t} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} editing={editing} />
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='paid_amount'>
            {t('paid')}
          </label>
          <input
            defaultValue={exp?.paid_amount}
            className={styles.entry_input}
            required
            type='number'
            step='0.01'
            id='paid_amount'
            name='paid_amount'
          />
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='description'>
            {t('description')}
          </label>
          <textarea defaultValue={exp?.description || ''} className={styles.entry_input} type='text' id='description' name='description' />
        </div>
        <div className={styles.form_entry}>
          <button className={styles.submit_button} type='submit'>
            {data ? t('save') : t('add')}
          </button>
        </div>
      </form>
    </div>
  )
}
export default index
